"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PercentTag = void 0;

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

var PercentTag = function PercentTag(_ref) {
  var percent = _ref.percent,
      progressBarType = _ref.progressBarType;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    className: "status-".concat(progressBarType),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      children: [percent, "%"]
    })
  });
};

exports.PercentTag = PercentTag;